/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck — vite-plugin-svgr transforms these to React components at build time
import addedtocart from "./addedtocart.svg?react";
import backicon from "./backicon.svg?react";
import barcode from "./barcode.svg?react";
import basket from "./basket.svg?react";
import basketleft from "./basketleft.svg?react";
import calendar from "./calendar.svg?react";
import checkmark from "./checkmark.svg?react";
import chevron from "./chevron.svg?react";
import clipboard from "./clipboard.svg?react";
import close from "./close.svg?react";
import crane from "./crane.svg?react";
import da from "./da.svg?react";
import de from "./de.svg?react";
import discount from "./discount.svg?react";
import es from "./es.svg?react";
import externallink from "./externallink.svg?react";
import facebook from "./facebook.svg?react";
import fallback from "./fallback.svg?react";
import favorites from "./favorites.svg?react";
import fr from "./fr.svg?react";
import globe from "./globe.svg?react";
import heart from "./heart.svg?react";
import heartfull from "./heartfull.svg?react";
import hmflogo from "./hmf-logo.svg?react";
import hmfloader from "./hmfloader.svg?react";
import info from "./info.svg?react";
import instagram from "./instagram.svg?react";
import linkedin from "./linkedin.svg?react";
import mail from "./mail.svg?react";
import menu from "./menu.svg?react";
import orderhistory from "./orderhistory.svg?react";
import pdf from "./pdf.svg?react";
import pencil from "./pencil.svg?react";
import plus from "./plus.svg?react";
import profile from "./profile.svg?react";
import quickorder from "./quickorder.svg?react";
import quickordertable from "./quickordertable.svg?react";
import register from "./register.svg?react";
import search from "./search.svg?react";
import serialsearch from "./serialsearch.svg?react";
import smallarrowright from "./smallarrowright.svg?react";
import trashcan from "./trashcan.svg?react";
import uk from "./uk.svg?react";
import warning from "./warning.svg?react";
import youtube from "./youtube.svg?react";
import React from "react";

const icons: Record<string, React.FC<React.SVGProps<SVGElement>>> = {
    addedtocart,
    backicon,
    barcode,
    basket,
    basketleft,
    calendar,
    checkmark,
    chevron,
    clipboard,
    close,
    crane,
    da,
    de,
    discount,
    es,
    externallink,
    facebook,
    fallback,
    favorites,
    fr,
    globe,
    heart,
    heartfull,
    "hmf-logo": hmflogo,
    hmfloader,
    info,
    instagram,
    linkedin,
    mail,
    menu,
    orderhistory,
    pdf,
    pencil,
    plus,
    profile,
    quickorder,
    quickordertable,
    register,
    search,
    serialsearch,
    smallarrowright,
    trashcan,
    uk,
    warning,
    youtube,
};

export const getIcon = (name: string): React.FC<React.SVGProps<SVGElement>> | undefined => {
    return icons[name.toLowerCase()];
};
